@import "~@swisscom/sdx/stylesheets/sdx/variables/colors";
@import "~@swisscom/sdx/stylesheets/sdx/variables/sizes";
@import "~@swisscom/sdx/stylesheets/sdx/variables/grid";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/breakpoints";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/mediaqueries";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/typography";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/text";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/misc";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/core";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/button";
@import "~@swisscom/sdx/stylesheets/sdx/variables/global";
@import "~@swisscom/sdx/stylesheets/sdx/button/button";
@import "~@swisscom/sdx/stylesheets/sdx/link/link";
@import "~@swisscom/sdx/stylesheets/sdx/typography/typography";
@import "~@swisscom/sdx/stylesheets/sdx/css-variables-tokens-desktop";
@import "~@swisscom/sdx/stylesheets/sdx/css-variables-tokens-functional-and-mobile";

.cards {
  // ul reset
  list-style: none;
  padding: 0;
  margin: 0;
}

.add-spacer {
  background: #fff;
}

.trailing-spacer {
  height: 0;
}

.card-container {
  display: flex;
  flex-direction: column;
  position: relative;
}

.card-image-container {
  position: absolute;
  width: 100%;
  height: 256px;
  transition: opacity 200ms ease;
  padding: 0 0 32px;
  z-index: 1;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -0;
    height: 32px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.7) 100%
    );
  }

  &.visible {
    opacity: 1 !important;
  }

  &.fade-out {
    opacity: 0;
  }
}

.leading-spacer {
  position: absolute;
  top: -200px;
  height: 456px;
  width: 100%;
  background: none;
  z-index: -1;
}

.add-spacer {
  background: #fff;
}

.card-image {
  width: 100%;
  height: 256px;
  border-radius: var(--sdx-border-radius-xlarge);
  object-fit: cover;
  object-position: center;
}

.card-text-content {
  display: flex;
  flex-direction: column;
  padding: 300px 0 32px;
  opacity: 1;
  transition: opacity 200ms ease;
}

.active .card-text-content {
  opacity: 1;
}

.card-title,
.card-description {
  margin-bottom: 16px;
}

.trailing-spacer {
  height: 288px;
}

@media (min-width: 768px) {
  .leading-spacer {
    display: none;
  }
  .add-spacer {
    display: none;
  }
  .card-image-container.fade-out {
    opacity: 1; // disable mobile-transparency for desktop
  }

  .card-container {
    display: flex;
    flex-direction: row;
    height: 500px;
    position: unset;
  }

  .card-image-container {
    position: unset;
    top: unset;
    padding: unset;
    background: unset;
    opacity: 0;

    &::after {
      display: none;
    }
  }

  .card-image {
    width: 100%;
    height: 119%;
    border-radius: var(--sdx-border-radius-xlarge);
    object-fit: cover;
    object-position: center;
  }

  .card-text-content {
    display: flex;
    padding: 200px 0 100px 24px;
    flex-direction: column;
    justify-content: center;
    min-width: 300px;
  }

  .image-right .card-text-content {
    padding: 200px 24px 100px 0;
  }

  .trailing-spacer {
    height: 105px;
  }
}

@media (min-width: 1024px) {
  .card-image {
    height: 153%;
  }

  .trailing-spacer {
    height: 192px;
  }
}

@media (min-width: 1280px) {
  .card-image {
    height: 219%;
  }

  .trailing-spacer {
    height: 361px;
  }
}
